import ApiClient from './ApiClient';

class SipColleaguesAPI extends ApiClient {
  constructor() {
    super('sip_colleagues', { accountScoped: true });
  }
}

export default new SipColleaguesAPI();
